
export { gaLoadedPromise } from "/app/src/utils/gtagEvents.ts"